import { reactive } from 'vue'

// Global reactive toast state
export const toastState = reactive({
  show: false,
  message: '',
  color: 'error',
  timeout: 3000,
  location: 'top', // Default location: 'top' | 'bottom' | 'left' | 'right' | 'top left' | 'top right' | 'bottom left' | 'bottom right' | etc.
})

// Toast service methods
export const toast = {
  error(message, timeout = 3000, location = 'top') {
    toastState.message = message
    toastState.color = 'error'
    toastState.timeout = timeout
    toastState.location = location
    toastState.show = true
  },
  
  warning(message, timeout = 3000, location = 'top') {
    toastState.message = message
    toastState.color = 'warning'
    toastState.timeout = timeout
    toastState.location = location
    toastState.show = true
  },
  
  success(message, timeout = 3000, location = 'top') {
    toastState.message = message
    toastState.color = 'success'
    toastState.timeout = timeout
    toastState.location = location
    toastState.show = true
  },
  
  info(message, timeout = 3000, location = 'top') {
    toastState.message = message
    toastState.color = 'info'
    toastState.timeout = timeout
    toastState.location = location
    toastState.show = true
  },
}
